/**
 * 拼接URL地址
 * @param {string} url
 * 原URL地址
 * @param {string} paramesData
 * 参数对象：Object
 * @param {string} beforeHash
 * 是否凭借在hash之前，默认为false；有#时才生效
 * @returns string 完整的url地址
 */
export var linkSpell = function linkSpell(url, paramesData, beforeHash) {
  if (beforeHash === void 0) {
    beforeHash = false;
  }

  if (!paramesData) return url;
  var parames = '';

  if (typeof paramesData === 'object') {
    parames = Object.entries(paramesData).map(function (d) {
      return (d[0] || '') + "=" + (d[1] || '');
    }).join('&');
  }

  if (url.indexOf('#') >= 0) {
    var urls = url.split('#');

    if (beforeHash) {
      urls[0] += (urls[0].indexOf('?') >= 0 ? '&' : '?') + parames;
    } else {
      urls[1] += (urls[1].indexOf('?') >= 0 ? '&' : '?') + parames;
    }

    return urls[0] + '#' + urls[1];
  }

  return url + (url.indexOf('?') >= 0 ? '&' : '?') + parames;
}; // 获取当前用于微信鉴权的url

export var getDomainPath = function getDomainPath() {
  return process.env.NODE_ENV === 'development' && localStorage.MOCK_DOMAIN || location.href.split('#')[0];
};